import React from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useSubscriptionStatus } from '../../../hooks/useSubscriptionStatus';
import { Organization } from '../../../models/organization';

interface SubscriptionGuardProps {
  organization: Organization | null;
  children: React.ReactNode;
  showAlert?: boolean;
  className?: string;
}

export const SubscriptionGuard: React.FC<SubscriptionGuardProps> = ({
  organization,
  children,
  showAlert = true,
  className = '',
}) => {
  const navigate = useNavigate();
  const subscriptionStatus = useSubscriptionStatus(organization);

  const handleResumeSubscription = () => {
    navigate('/paywall');
  };

  if (subscriptionStatus.isActive) {
    return <>{children}</>;
  }

  return (
    <div className={className} style={{ position: 'relative' }}>
      {children}

      {/* Subtle overlay for inactive subscriptions */}
      {subscriptionStatus.isInactive && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: subscriptionStatus.isCancelled
              ? 'rgba(220, 53, 69, 0.05)'
              : 'rgba(255, 193, 7, 0.05)',
            pointerEvents: 'none',
            zIndex: 1,
          }}
        />
      )}
    </div>
  );
};

export default SubscriptionGuard;
